import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';

import '@styles/main.less';

import CouponsList from './Coupons';
import CreateCoupon from './CreateCoupon';
import ViewCoupon from './ViewCoupon';

function CouponsPage(props) {
  const {
    match: { url }
  } = props;

  return (
    <Switch>
      <Route exact path={`${url}/`} component={CouponsList} />
      <Route exact path={`${url}/create`} component={CreateCoupon} />
      <Route path={`${url}/:id`} component={ViewCoupon} />
    </Switch>
  );
}

CouponsPage.propTypes = {
  match: PropTypes.object
};

export default CouponsPage;
